<p-breadcrumb [model]="routePath"></p-breadcrumb>

<div class="flex">
    <div class="col-fixed bg-surface hide-scrollbar">
        <div class="navigation-menu">
            <div appAccessProvider [accessCode]="{ menuCode: 'SETTINGS'}" class="flex my-2">
                <div>
                    <span>
                        <i class="{{miIcons.USER_CIRCLE}} block wh-20"></i>
                    </span>
                </div>
                <div>
                    <p class="font-semibold mx-3 pb-3" translate>settings.lbl_account_settings</p>
                </div>
                <div>
                    <a class="default-text-blue-color ml-4 cursor-pointer" (click)="doLogOut()" translate>settings.lbl_logout</a>
                </div>
            </div>
            <div appAccessProvider [accessCode]="{ menuCode: 'SETTINGS', subMenuCode: 'GENERAL_SETTING', pageCode: 'USER_PROFILE', subPageCode: 'EDIT'}"
                class="navigation-item" [routerLink]="['/app/settings/user-profile']"
                (click)="setActiveSection(sectionHandlers.userProfile); updateBreadcrumb('User Profile')"
                [ngClass]="{'active': activeSection === sectionHandlers.userProfile}">
                <label class="navigation-item-label" translate>settings.lbl_user_profile</label>
            </div>
            <div appAccessProvider [accessCode]="{menuCode: 'SETTINGS', subMenuCode: 'GENERAL_SETTING', pageCode: 'NOTIFICATION_AND_EMAIL', subPageCode: 'EDIT'}"
                class="navigation-item" [routerLink]="['/app/settings/notification-settings']"
                (click)="setActiveSection(sectionHandlers.notificationSettings); updateBreadcrumb('Notification Settings')"
                [ngClass]="{'active': activeSection === sectionHandlers.notificationSettings}">
                <label class="navigation-item-label" translate>settings.lbl_notification_settings</label>
            </div>
            <div appAccessProvider [accessCode]="{ menuCode: 'SETTINGS', subMenuCode: 'GENERAL_SETTING', pageCode: 'USER_PROFILE', subPageCode: 'EDIT' }"
                class="navigation-item" [routerLink]="['/app/settings/login-and-password']"
                (click)="setActiveSection(sectionHandlers.loginPassword); updateBreadcrumb('Change Password')"
                [ngClass]="{'active': activeSection === sectionHandlers.loginPassword}">
                <label class="navigation-item-label" translate>settings.lbl_change_password</label>
            </div>
        </div>

        @if(!hideAdminSection){

            <div class="navigation-menu">
                <div appAccessProvider [accessCode]="{ menuCode: 'ADMINISTRATION'}" class="flex my-2">
                    <div>
                        <span>
                            <i class="{{miIcons.ORDER_MANAGEMENT}} block wh-20"></i>
                        </span>
                    </div>
                    <div>
                        <p class="font-semibold mx-3" translate>settings.lbl_order_management</p>
                    </div>
                </div>
                <div appAccessProvider [accessCode]="{ menuCode: 'SETTINGS', subMenuCode: 'ORDER_MANAGEMENT', pageCode: 'GENERAL', subPageCode: 'EDIT' }"
                    class="navigation-item" [routerLink]="['/app/settings/general-order-management']" (click)="setActiveSection(sectionHandlers.generalManagement); updateBreadcrumb('General Order Management')"
                    [ngClass]="{'active': activeSection === sectionHandlers.generalManagement}">
                    <label class="navigation-item-label" translate>settings.lbl_settings_general_management</label>
                </div>
            </div>
        }
    </div>
    <div class="col p-0 scrollable">
        <div>
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
